module.exports = __webpack_public_path__ + "static/media/project_design_1_4.7ee30be8.webp";